<div class="container">
    <div class="header">
        <div class="form">
            <h1>LA PLANTILLA</h1>
            <form [formGroup]="service.playerAtletiForm">
                <mat-form-field>
                    <mat-label>Temporada</mat-label>
                    <mat-select formControlName="season" required>
                        <mat-option *ngFor="let season of seasons" [value]="season">{{season}}</mat-option>     
                    </mat-select>
                </mat-form-field>
            </form>
        </div>
        <span class="example-spacer"></span>
        <button *ngIf="auth.isEditor()" mat-button class="download-button" (click)="onAddPlayer()" aria-label="Add players">
            <mat-icon>add</mat-icon>
            Player
        </button>
    </div>

    <mat-card appearance="outlined">
        <mat-card-content>
            <div class="responsive_table">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">        
                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by player.name">
                            Name
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.player.name}} </td>
                    </ng-container>
                    <!-- Nation Column -->
                    <ng-container matColumnDef="nation">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by player.nation">
                            Nation
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.player.nation}} </td>
                    </ng-container>
                    <!-- Age Column -->
                    <ng-container matColumnDef="age">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by player.age">
                            Age
                        </th>
                        <td mat-cell *matCellDef="let element"> {{displayFn(element.player.age)}} </td>
                    </ng-container>
                    <!-- Delete Column -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>   
                        <td mat-cell *matCellDef="let element"> 
                        <button [disabled]="!auth.isRoot()" mat-button (click)="onDelete(element._id)">
                            <mat-icon>delete</mat-icon>
                        </button> 
                        </td>
                    </ng-container>
            
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons aria-label="Select page"></mat-paginator>
        </mat-card-content>
    </mat-card>
</div>